import {useState, useEffect} from 'react';

function useStores(storeList) {
  const [count, setCount] = useState(0);
  const storeListeners = [];

  useEffect(() => {
    // setup function
    let nrStores = 0;
    storeList.forEach((item) => {
      storeListeners[nrStores] = () => setCount(count + 1);
      item.addChangeListener(storeListeners[nrStores]);
      nrStores++;
    });

    // cleanup function
    return (
      () => {
        nrStores = 0;
        storeList.forEach((item) => {
          item.removeChangeListener(storeListeners[nrStores]);
          nrStores++;
        });
    });
  });
};

export default useStores;
